export default __webpack_public_path__ + "cc51fd79b2526b485025c76e12dac246.png";